import { render } from "./TeacherSignup.vue?vue&type=template&id=4dc282f3"
import script from "./TeacherSignup.vue?vue&type=script&lang=js"
export * from "./TeacherSignup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__